import React, { useRef } from 'react';
import { find, is, prop, propEq, sortBy, isNil } from 'ramda';
import { useIntl } from 'gatsby-plugin-intl';
import { renderWhenTrue } from '../../utils/rendering';
import { BLOCK_ELEMENTS } from '../../utils/constants';
import {
  Container,
  Header,
  Title,
  Navigation,
  Button,
  PreviousArrowIcon,
  NextArrowIcon,
  Card,
  CardHeader,
  ImageComponent,
  CardTitle,
  CardContent,
  CardContentWrapper,
  Slider,
  CardWrapper,
} from './videoCardCarousel.styles';
import { CardVideo } from '../cardVideo';
import { getSliderSettings, SLIDER_VARIANTS } from '../slider';

const renderTitle = ({ value }) => {
  const intl = useIntl();
  return <Title>{intl.formatMessage({ id: value })}</Title>;
};

const renderVideo = (youtubeObj, imageCover) => {
  if(!youtubeObj || !imageCover) return null
  return <CardVideo youtubeObj={youtubeObj} imageCover={imageCover} />
}

const renderImage = ( url ) => renderWhenTrue(() => <ImageComponent src={url} />)(!!url);

const renderCardTitle = ({value}) => {
  if (!value || !is(String, value)) return null;
  const intl = useIntl()
  return (
    <CardTitle>
      {intl.formatMessage({ id: value })}
    </CardTitle>
  )
}

const renderCardHeader = (value, url) => {
  return (
    <CardHeader>
      {renderImage(url)}
      {renderCardTitle(value)}
    </CardHeader>
  )
}

const renderCardContent = ({ value }, key) => {
  if (!value || !is(String, value)) return null;
  const intl = useIntl();
  return (
    <CardContent key={key}>
      {intl.formatMessage({ id: value })}
    </CardContent>
  );
};


export const VideoCardCarousel = ({ elements }) => {
  const getElement = (name) => find(propEq('name', name))(elements) || {};
  const title = getElement(BLOCK_ELEMENTS.TITLE);
  const cards = getElement(BLOCK_ELEMENTS.CARD);
  const slider = useRef(null);

  const handleNextClick = () => {
    if (!isNil(slider)) {
      slider.current.slickNext();
    }
  };

  const handlePreviousClick = () => {
    if (!isNil(slider)) {
      slider.current.slickPrev();
    }
  };

  const renderCard = ({ elements = [] }, key) => {
    const header = find(propEq('name', 'plain_text'))(elements) || {};
    const image = find(propEq('name', 'image'))(elements) || {};
    const markdown = find(propEq('name', 'markdown'))(elements) || {};
    const youtubeObj = find(propEq('name', 'Youtube URL'))(elements) || {};
    const imageCover = find(propEq('name', 'Image Cover'))(elements) || {};

    return (
      <Card key={key}>
        {renderVideo(youtubeObj, imageCover)}
        {renderCardHeader(header, image.value.image)}
        {renderCardContent(markdown)}
      </Card>
    )
  }

  const renderCards = ({ value = [] }) => sortBy(prop('order'))(value).map(renderCard);

  return (
    <Container>
      <Header>
        {renderTitle(title)}
        <Navigation>
          <Button onClick={handlePreviousClick}>
            <PreviousArrowIcon />
          </Button>
          <Button onClick={handleNextClick}>
            <NextArrowIcon />
          </Button>
        </Navigation>
      </Header>
      <CardWrapper>{renderCards(cards)}</CardWrapper>
      <Slider {...getSliderSettings()} ref={slider} variant={SLIDER_VARIANTS.EQUAL_HEIGHT} itemWidth={300}>
        {renderCards(cards)}
      </Slider>
    </Container>
  );
};
